export default {
    mounted(el, binding) {
        const delay = binding.value || 300;
        const disableButton = !binding.modifiers.prevent;

        const handleClick = () => {
            if (disableButton) {
                el.disabled = true;
            }
            setTimeout(() => {
                if (disableButton) {
                    el.disabled = false;
                }
            }, delay);
        };

        el.addEventListener('click', handleClick);

        el._handleClick = handleClick; // 保存引用以便在卸载时移除监听器
    },
    unmounted(el) {
        el.removeEventListener('click', el._handleClick);
    },
};